module.exports = __webpack_public_path__ + "img/adidas.7b7be444.svg";